module.exports = __webpack_public_path__ + "47d7dd58c2cc510b5508efdcd029f345.png";